var _line, _circle, _circle2, _path, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckscansvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 332,
    viewBox: "0 0 41 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.5,
    y1: 41.5,
    x2: 20.5,
    y2: 289.5,
    stroke: "#E4DCDC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1618,
    cy: 20.1618,
    r: 20.1618,
    fill: "url(#paint0_linear_5857_23293)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1618,
    cy: 20.1618,
    r: 19.3218,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.68015
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.082 21.4141L16.8026 28.1347L30.2439 14.2734",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 3.36031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1618,
    cy: 311.162,
    r: 19.3218,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.68015
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5857_23293",
    x1: 0,
    y1: 0,
    x2: 72.7372,
    y2: 8.59727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckscansvg1);
export default __webpack_public_path__ + "static/media/checkscansvg1.87a77f1397337185f350ff5f68c1cb8b.svg";
export { ForwardRef as ReactComponent };